// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Popup__Popup___NkdCE{background:var(--dc-global-color-background);border-radius:4px;display:flex;filter:drop-shadow(0 4px 10px rgba(0,0,0,.14));flex-direction:column;flex-shrink:0;min-height:176px;position:absolute;width:332px;z-index:10000}.Popup__PopupHeader___3bTHA{display:flex;height:40px;position:relative}.Popup__CloseButtonContainer___3efzb{position:absolute;right:4px;top:4px}.Popup__PopupContent___19wqy{display:flex;flex:1 1;flex-direction:column;height:auto}@keyframes Popup__slideUp___247M2{0%{opacity:0;transform:translateY(100%)}to{opacity:1;transform:translateY(0)}}", ""]);
// Exports
exports.locals = {
	"Popup": "Popup__Popup___NkdCE",
	"PopupHeader": "Popup__PopupHeader___3bTHA",
	"CloseButtonContainer": "Popup__CloseButtonContainer___3efzb",
	"PopupContent": "Popup__PopupContent___19wqy",
	"slideUp": "Popup__slideUp___247M2"
};
module.exports = exports;
